// extracted by mini-css-extract-plugin
module.exports = {"close":"a10a3f92e9--close--V8z4X","title":"a10a3f92e9--title--AFEXU","actions":"a10a3f92e9--actions--mrFZJ"};